import types from "../types";
import {
  showSuccessSnackbar,
  showFailSnackbar,
} from "../../common/actions/snackbar";
import { push } from "../../router/history";

export function deleteScreen(values) {
  return async (dispatch) => {
    return dispatch({
      type: types.DELETE,
      payload: {
        request: {
          url: "powerbi/delete",
          method: "POST",
          data: values,
        },
      },
    })
    .then(async ({ payload }) => {
      dispatch(
        showSuccessSnackbar(
          "Sucesso! A Tela foi removida."
        )
      );
    })
    .catch((error) => {
      console.log("error---", error);
      dispatch(
        showFailSnackbar("Ops! Algo deu errado, tente novamente mais tarde.")
      );
    });
  };
}

export function getScreens() {
  return async (dispatch) => {
    return dispatch({
      type: types.LIST,
      payload: {
        request: {
          url: "powerbi/",
          method: "GET",
        },
      },
    });
  };
}
